import WaitingForHR from '../components/MessagePages/WaitingForHR';
import PageLayout from '../components/pageLayout';

function WaitingForHRPage() {
    return (
        <PageLayout children={<WaitingForHR />} />
    );
}

export default WaitingForHRPage;
